<template>
  <div class="main">
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    ></SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :btns="btns"
      :allBtnWidth="allBtnWidth"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :showTotal="true"
      :getTotal="getTotal"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="photo" slot-scope="params">
        <div class="photos">
          <div
            class="wrap"
            v-for="(c, i) in params.params.reimburse_bill"
            :key="'reimburse_bill' + i"
          >
            <el-image
              class="img"
              :src="c.url"
              :preview-src-list="params.params.urls"
            ></el-image>
          </div>
        </div>
        <span v-if="!params.params.reimburse_bill || !params.params.reimburse_bill[0]"
          >-</span
        >
      </template>
    </Table>

    <FormDialog
      class="dialog"
      ref="dialog"
      :title="title"
      :width="'330px'"
      :labelWidth="'0px'"
      :form="mform"
      :rules="mrules"
      :formCtrl="mformCtrl"
      :viewMode="viewMode"
      @onModalSubmit="onModalSubmit"
    ></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "reimburse",
      getOptionUrl: "options",
      modalSubmitUrl: "reject",
      formInline: {
        status: 0,
      },
      baseParams: ["group_name", "status"],
      formCtrl: [
        {
          label: "报销人",
          keyName: "reimburse_user_name",
          placeholder: "请选择报销人",
          type: "select",
          options: [],
        },
        {
          label: "申请时间",
          keyName: "apply_at",
          placeholder: "请选择时间",
          type: "daterange",
        },
      ],
      cols: [
        { prop: "reimburse_user_name", label: "报销人" },
        { prop: "reimburse_content", label: "报销事项" },
        { prop: "reimburse_amount", label: "报销金额" },
        { prop: "apply_at", label: "申请时间" },
        { prop: "reimburse_bill", label: "票据", slot: "photo" },
      ],
      getTotalProperty: ["reimburse_amount"],
      allBtnWidth: 200,
      btns: [
        {
          class: "passbtn",
          title: "通过",
          type: "primary",
          size: "mini",
          cb: (data) => {
            console.log(data);
            this.$confirm("确认通过吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.passReq(data);
              })
              .catch(() => {});
          },
        },
        {
          class: "rejectbtn",
          title: "驳回",
          type: "danger",
          plain: true,
          size: "mini",
          cb: (data) => {
            // console.log(data)
            this.mform["id"] = data.id;
            this.mform["reject_user_name"] = this.user.nickname;
            this.showDialog();
          },
        },
      ],
      title: "驳回理由",
      viewMode: false,
      mform: { reject_reason: undefined },
      mrules: {
        reject_reason: [
          {
            required: true,
            message: "请填写驳回理由",
            trigger: "blur",
          },
        ],
      },
      mformCtrl: [
        {
          label: "",
          keyName: "reject_reason",
          err: "请填写驳回理由",
          type: "textarea",
        },
      ],
    };
  },
  methods: {
    tableDataHandler(res) {
      if (typeof res === "string") {
        this.$message({
          type: "error",
          message: res,
        });
      } else {
        const { count, data } = res;
        this.total = count;
        if (data && data.length) {
          this.tableData = data.map((v) => {
            const obj = this.dataObjHandler(v);
            obj.urls = [];
            // console.log({ ...obj })
            // 预览图片
            obj.reimburse_bill &&
              obj.reimburse_bill.map((o) => {
                obj.urls.push(o.url);
              });
            return obj;
          });
        }
      }
    },
    passReq({ id }) {
      const url = `${this.baseUrl}/review`;
      const params = {
        id,
        group_name: this.user.group_name,
      };

      params["headers"] = {
        "X-Method": "review",
        "X-Module": "reimburse",
      };

      console.log(url, { ...params });

      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "提交失败",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },

    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key];
          params[key] = value;
        }
      }

      params["headers"] = {
        "X-Method": "reject",
        "X-Module": "reimburse",
      };
    },

    setOptions({ data: { reimburse_user_list } }) {
      this.formCtrl.map((c) => {
        if (
          c.keyName == "reimburse_user_name" &&
          reimburse_user_list &&
          reimburse_user_list.length
        ) {
          c.options = reimburse_user_list.map((v) => {
            return {
              label: v.nickname,
              value: v.nickname,
            };
          });
          // console.log(c.options)
        }
      });
      this.$forceUpdate();
    },
  },
  mounted() {
    this.getOptions();
    const { group_name } = this.user;
    this.$set(this.formInline, "group_name", group_name);
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .table-wrap {
    .el-table {
      .cell {
        img {
          width: 100%;
          height: 100%;
        }
      }

      .el-image {
        max-height: 50px;
        max-width: 50px;
      }

      .photos {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .wrap {
          width: 50px;
          height: 50px;
          border: 1px solid #bbb;
          box-sizing: border-box;
          border-radius: 5px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    .el-dialog__header {
      padding: 15px 20px 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-form {
      padding-right: 0;
      margin: 20px;

      .el-form-item .el-form-item__content .content {
        display: block;
      }
    }
  }
}
</style>
